<template>
    <div class="uploader">
        <div class="uploader-list">
            <div v-for="(item, index) in images" v-bind:key="index" class="uploader-grid">
                <img :src="item + '@!thumb.png'" class="uploader-img" @click="previewImageAt(index)" />
                <div class="uploader-close" @click="deleteImageAt(index)"></div>
            </div>
            <div class="uploader-grid uploader-btn" v-if="images.length < maxNum">
                <input type="file" @change="onFileUpload" name="file" accept="image/*" :multiple="maxNum>1" />
                <i class="uploader-btn_icon"></i>
                <div class="uploader-btn_label">上传图片</div>
            </div>
        </div>
    </div>
</template>

<script>
    import api from "./utils/api.js";
    import getRawImages from "./utils/getRawImages.js";
    export default {
        name: "Uploader",
        props: {
            maxNum: {
                type: Number,
                default: 8
            },
            userImgs: {
                type: Array,
                default: function() {
                    return []
                }
            },
            maxSize: {
                type: Number,
                default: 10 * 1024 * 1024
            }
        },
        data() {
            return {
                images: getRawImages(this.userImgs),
            }
        },
        methods: {
            onFileUpload(e) {
                const files = e.currentTarget.files;
                if (!files || files.length <= 0) return;
                if (!this.checkValid(files)) {
                    return;
                }
                this.$emit("start");
                api.uploadMultiple({
                    files,
                    success: res => {
                        this.images = this.images.concat(res);
                        this.$emit("change", this.images);
                    },
                    fail: err => {
                        this.$emit("error", err);
                    }
                })
            },
            deleteImageAt(idx) {
                if (idx < 0 || idx >= this.images.length) return;
                this.images.splice(idx, 1);
                this.$emit("change", this.images);
            },
            checkValid(newImages) {
                const currentNum = this.images.length;
                const newNum = newImages.length;
                const maxNum = this.maxNum;
                if (currentNum + newNum > this.maxNum) {
                    this.$emit("error", "最多上传" + maxNum + "张图片");
                    return false;
                }
                const maxSize = this.maxSize;
                const hasTooLargeImages = Array.prototype.some.call(newImages, function(file) {
                    return file.size > maxSize;
                });
                if (hasTooLargeImages) {
                    this.$emit("error", "图片尺寸太大");
                    return false;
                }
                return true;
            },
            previewImageAt(index) {
                this.$emit("preview", index, this.images);
            }
        }
    }
</script>

<style scoped src="./uploader.css">

</style>